import { createChannelDescriptor } from "./channel-descriptor.js";

export const createDebugChannel = <TDomain extends "host" | "remote">(
  domain: TDomain
) => {
  return createChannelDescriptor(domain, "debug", {
    hostMethods: () => {
      return {
        echo: async (message: string) =>
          console.log("[debug:host] echo", message),
      };
    },
    remoteMethods: () => {
      return {
        echo: async (message: string) =>
          console.log("[debug:remote] echo", message),
      };
    },
  });
};
